import concat from '@epimodev/callbag-doki/sources/concat';

import {
  aggregatedMatchSnapshot,
  liveAggregatedMatch,
  liveMatch,
  liveMicrobetting
} from './entities/match';
import { getBackendUrl, getMicrobetWsUrl, getWsUrl } from './api_url';
import { isDefined } from './types';

const loadLiveMatchData = (id: number, customer: string | undefined) => {
  const url = getWsUrl();
  return liveMatch(url, id, customer);
};

// Aggregated feed (grad widget): REST snapshot on load, then WS patches on
// channel `aggregated:match:{id}`.
const loadAggregatedMatchData = (id: number, customer: string | undefined) => {
  const restUrl = `${getBackendUrl()}/api/aggregated/matches/${id}/live?user_path_param=${
    customer ?? ''
  }`;
  return concat(aggregatedMatchSnapshot(restUrl), liveAggregatedMatch(getWsUrl(), id, customer));
};

const loadMicrobettingData = (id: number, jwt: string) => {
  const url = getMicrobetWsUrl();
  return liveMicrobetting(url, id, jwt);
};

const getXTotal = (headers: { [key: string]: string } | undefined): number => {
  if (headers && (headers['x-total'] || headers['x-total-count'])) {
    const total = headers['x-total'] || headers['x-total-count'];
    const value = parseInt(total, 10);
    if (isDefined(value) && !Number.isNaN(value)) {
      return value;
    }
  }
  return 0;
};

export { loadLiveMatchData, loadAggregatedMatchData, loadMicrobettingData, getXTotal };
